<template>
  <div class="v_look_for_pwd">
    <div class="v-look-for-title">
      <label class="iconfont icon-fanhui" @click="$router.replace({ name: 'login' })"></label>
      <span>找回密码</span>
      <!-- <div class="v-look-for-line"></div> -->
    </div>
    <div class="v-look-for-form g-flex-column g-flex-align-center">
      <!-- 手机号 -->
      <div class="v-look-for-form-item g-flex-column">
       <div class="v-look-for-form-item-title">
           <span>手机号</span>
           <!-- <div class="v-look-for-line"></div> -->
        </div>
        <van-field v-model="form.mobile"  placeholder="请输入手机号"/>
      </div>
      <!-- 新密码 -->
      <div class="v-look-for-form-item g-flex-column">
        <div class="v-look-for-form-item-title">
           <span>新密码</span>
           <!-- <div class="v-look-for-line"></div> -->
        </div>
        <div class="v-look-for-item-pwd g-flex-align-center">
          <van-field v-model="form.password" :type="pwdType"  placeholder="请输入新密码"/>
          <i class="iconfont" :class="pwdType ==='password' ? 'icon-bukejian': 'icon-mimakejianguanbi'" @click="pwdTypeClick"></i>
        </div>
      </div>
      <!-- 确认登录密码 -->
      <div class="v-look-for-form-item g-flex-column">
       <div class="v-look-for-form-item-title">
           <span>确认密码</span>
           <!-- <div class="v-look-for-line"></div> -->
        </div>
        <div class="v-look-for-item-pwd g-flex-align-center">
          <van-field v-model="form.password_two" :type="pwdTypeSecond"  placeholder="请再次输入新密码"/>
          <i class="iconfont" :class="pwdTypeSecond ==='password' ? 'icon-bukejian': 'icon-mimakejianguanbi'" @click="pwdTypeSecondClick"></i>
        </div>
      </div>

      <!-- 验证码 -->
      <div class="v-look-for-form-item g-flex-column">
       <div class="v-look-for-form-item-title">
           <span>验证码</span>
           <!-- <div class="v-look-for-line"></div> -->
        </div>
        <div class="v-look-for-item-code g-flex-align-center">
          <van-field v-model="form.mobile_code"  placeholder="请输入获取的验证码"/>
          <div class="v-look-for-code-btn g-flex-align-center g-flex-justify-center" @click="getCode">{{sendCodeText}}</div>
        </div>
      </div>

    </div>

    <div class="g-flex-justify-between">
      <operation-button :buttonObj="buttonObj" @clickItem="emitLoginClick"/>
    </div>

    <div class="v-look-for-bottom g-flex-justify-end">
      <span class="v-look-for-login" @click="$router.replace({ name: 'register' })">新用户注册</span>
    </div>

  </div>
</template>

<script>
import OperationButton from '../../components/OperationButton.vue'
import { apiForgetPassword, apiSendCode } from '@/utils/api.js'
  export default {
    components: { OperationButton },
    data() {
      return {
        pwdTypeSecond: 'password',
        pwdType: 'password',
        timer: 0,
        sendCodeText: '获取',
        defaultCodeText:'重新获取',
        buttonObj: {
          title: '确认',
          claSS: 'c-btn-default',
          event: 'apiForgetPasswordHandel',
        },
        form: {
          mobile:'',
          password: '',
          password_two: '',
          mobile_code: ''
        }
      }
    },
    methods: {
      pwdTypeSecondClick() {
        if(this.pwdTypeSecond === 'password') return this.pwdTypeSecond = 'text'
        return this.pwdTypeSecond = 'password'
      },
      pwdTypeClick() {
        if(this.pwdType === 'password') return this.pwdType = 'text'
        return this.pwdType = 'password'
      },
      emitLoginClick(event) {
        if(!event) return
        this[event]()
      },

      // 获取验证码
      getCode() {
        if(!(/^1\d{10}$/.test(this.form.mobile))) return this.$toast('手机号码有误，请重试'); 
        // if(!(/^1(3[0-9]|5[0-3,5-9]|7[1-3,5-8]|8[0-9])\d{8}$/.test(this.form.mobile))) return this.$toast('手机号码有误，请重试'); 
        if(this.timer) return
        this.apiSendCodeHandel()
      },

      // 发送验证码
      async apiSendCodeHandel() {
        this.$global.loadingShow = true
        const { success, data } = await apiSendCode({ mobile: this.form.mobile })
        if(!success) return
        let timeNum = 60
        this.$toast(data.msg)
        this.timer = setInterval(() => {
          timeNum --
          this.showNum = timeNum === 0 ? false : true
          this.sendCodeText = timeNum === 0 ? this.defaultCodeText : timeNum + 's'
          if(timeNum === 0) {
            clearInterval(this.timer)
            this.timer = 0
          }
        }, 1000)
      },

      // 忘记密码
      async apiForgetPasswordHandel() {
        if(!(/^1\d{10}$/.test(this.form.mobile))) return this.$toast('手机号码有误，请重试'); 
        // if(!(/^1(3[0-9]|5[0-3,5-9]|7[1-3,5-8]|8[0-9])\d{8}$/.test(this.form.mobile))) return this.$toast('手机号码有误，请重试'); 
        if(!this.form.password) return this.$toast('密码不能为空')
        if(this.form.password !== this.form.password_two) return this.$toast('请确认两次密码输入是否一致')
        if(!this.form.mobile_code) return this.$toast('请输入验证码')
        this.$global.loadingShow = true
        const { success, data } = await apiForgetPassword(this.form)
        if(!success) return
        this.$toast(data.msg)
        setTimeout(() => {
          this.$router.replace({ name: 'login' })
        }, 500);
        console.log(data)
      },
    }
  }
</script>

<style lang="scss">
.v_look_for_pwd {
  width: 100%;
  height: 100%;
  overflow: auto;
  // 登录标题
  .v-look-for-title {
    width: 180px;
    height: 100px;
    font-weight: bold;
    color: $black;
    position: relative;
    // 箭头
    .icon-fanhui {
      position: absolute;
      bottom: 0;
      font-size: 40px;
      font-weight: normal;
      z-index: 99;
      left: 10px;
      color: $main_color;
    }
    span {
      font-size: 32px;
      position: absolute;
      bottom: 0px;
      z-index: 99;
      right: 0;
    }
    .v-look-for-line {
      position: absolute;
      height: 10px;
      width: 100%;
      background: $main_color;
      bottom: 0;
      z-index: 88;
    }
  }
  // 表单
  .v-look-for-form {
    padding: 50px 40px 30px 50px;
    .v-look-for-form-item {
      align-self: stretch;
      .v-look-for-form-item-title {
        height: 30px;
        position: relative;
        span {
          padding-left: 10px;
          position: absolute;
          font-size: 18px;
          bottom: 0;
          z-index: 99;
          color: $black;
          font-weight: 600;
        }
        .v-look-for-line {
          position: absolute;
          height: 3px;
          width: 40px;
          background: $main_color;
          bottom: 4px;
          left: 34px;
          z-index: 88;
        }
      }
        // 密码
      .v-look-for-item-pwd {
        position: relative;
        .iconfont {
          position: absolute;
          right: 0;
          font-size: 24px;
          padding: 5px;
        }
      }
      // 设置输入框
      .van-cell {
        padding-left: 10px;
        border-bottom: 1px solid #B5B5B5;
        input {
          &::-ms-input-placeholder {
            color: #B2B2B2;
          }
          &::-webkit-input-placeholder {
            color: #B2B2B2;
          }
        }
      }
      // 验证码
      .v-look-for-item-code {
        border-bottom: 1px solid #B5B5B5;
        .van-cell {
          border-bottom: 0;
          flex: 1;
        }
        .v-look-for-code-btn {
          width: 70px;
          height: 30px;
          background: #FED9E1;
          color: $main_color;
          border-radius: 20px;
          font-size: 14px;
        }
      }
      // 登陆密码
      &:nth-of-type(3) {
        // margin-top: 24px;
        .v-look-for-form-item-title {
          .v-look-for-line {
            width: 60px;
          }
        }
      }
    }
  }

  .v-look-for-bottom {
    padding: 10px 30px;
    .v-look-for-login {
      color: $main_color;
      font-size: 12px;
      padding: 6px;
    }
  }
}
</style>